import { render } from "./Recipes.vue?vue&type=template&id=34393798"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__